export default "__VITE_ASSET__fd78252f__"